/**
 * @param {object} obj
 * @return {string[]}
 */
const keys = (obj) => Object.keys(obj);

export { keys };
